import { pickValuesFromColorScheme } from '../../../colorUtils';
import { stringLiteralsArray } from '../../../../utils';
export var headerDescriptionColorAreas = stringLiteralsArray('foreground');
export default (function (siteVariables) {
  return {
    colorScheme: pickValuesFromColorScheme(siteVariables.colorScheme, headerDescriptionColorAreas),
    color: siteVariables.colors.grey[350]
  };
});